module.exports = __webpack_public_path__ + "img/starter.289e2715.svg";